var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "roles" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c(
            "Form",
            {
              attrs: { "label-width": 70, model: _vm.search, id: "searchForm" },
            },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "地区名称" } },
                        [
                          _c("Input", {
                            attrs: { clearable: true },
                            model: {
                              value: _vm.search.areaName,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "areaName", $$v)
                              },
                              expression: "search.areaName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "pc端", "label-width": 45 } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.pc,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "pc", $$v)
                                },
                                expression: "search.pc",
                              },
                            },
                            _vm._l(_vm.pcList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  staticStyle: { width: "100%" },
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "小程序端" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.miniProgram,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "miniProgram", $$v)
                                },
                                expression: "search.miniProgram",
                              },
                            },
                            _vm._l(_vm.miniProgramList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  staticStyle: { width: "100%" },
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态", "label-width": 45 } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "status", $$v)
                                },
                                expression: "search.status",
                              },
                            },
                            _vm._l(_vm.statusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  staticStyle: { width: "100%" },
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Col", [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _vm._v("\n              "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.query },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "5px",
                display: "flex",
                width: "100%",
              },
              attrs: { slot: "extra" },
              slot: "extra",
            },
            [
              _c(
                "div",
                { staticStyle: { float: "left" } },
                [
                  _c(
                    "Button",
                    {
                      attrs: { size: "small", icon: "md-add", type: "primary" },
                      on: { click: _vm.handleCreate },
                    },
                    [_vm._v("添加")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "header-cell-style": {
              background: "#f8f8f9",
              color: "#515a6e",
              "text-align": "center",
              height: "40px",
            },
            "row-class-name": _vm.tableRowClassName,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "row-key": "id",
            "max-height": _vm.tableHeight,
          },
          on: { "row-click": _vm.selectrow },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "areaName",
              label: "地区",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "code",
              label: "校验码",
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "areaCode",
              label: "地区编号",
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "expiredTime",
              label: "失效时间",
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "pc",
              label: "pc端",
              "min-width": "60",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 2 },
                      on: {
                        change: function ($event) {
                          return _vm.handleEditPC(row, null, row.pc)
                        },
                      },
                      model: {
                        value: row.pc,
                        callback: function ($$v) {
                          _vm.$set(row, "pc", $$v)
                        },
                        expression: "row.pc",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "miniProgram",
              label: "小程序端",
              "min-width": "60",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 2 },
                      on: {
                        change: function ($event) {
                          return _vm.handleEditMiniProgram(
                            row,
                            null,
                            row.miniProgram
                          )
                        },
                      },
                      model: {
                        value: row.miniProgram,
                        callback: function ($$v) {
                          _vm.$set(row, "miniProgram", $$v)
                        },
                        expression: "row.miniProgram",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "operator",
              label: "最后操作人",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(_vm._s(row.operatorAccount))]),
                    _c("div", [_vm._v(_vm._s(row.operator))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "updateTime",
              label: "最后操作时间",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "status",
              label: "状态",
              "min-width": "60",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 2 },
                      on: {
                        change: function ($event) {
                          return _vm.handleEditStatus(row, null, row.status)
                        },
                      },
                      model: {
                        value: row.status,
                        callback: function ($$v) {
                          _vm.$set(row, "status", $$v)
                        },
                        expression: "row.status",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "operation",
              label: "操作",
              "min-width": "50",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "medium" },
                        on: {
                          click: function ($event) {
                            return _vm.setTime(row)
                          },
                        },
                      },
                      [_vm._v("设置")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("Page", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          total: _vm.pageList.total,
          current: _vm.pageList.currentPage,
          "page-size": _vm.pageList.pageSize,
          "show-elevator": "",
          "show-sizer": "",
          "show-total": "",
          "page-size-opts": [10, 30, 50, 100],
        },
        on: {
          "on-change": _vm.chagecurrent,
          "on-page-size-change": _vm.chagepagesize,
        },
      }),
      _c(
        "Modal",
        {
          ref: "modalRef",
          attrs: {
            width: "30%",
            title: _vm.windowTitle,
            styles: { top: "60px" },
            "mask-closable": false,
          },
          model: {
            value: _vm.editWindow,
            callback: function ($$v) {
              _vm.editWindow = $$v
            },
            expression: "editWindow",
          },
        },
        [
          _c("WechatLoginCodeEdit", {
            ref: "edit",
            on: { "on-submit": _vm.handleSubmit },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确定")]
              ),
              _c(
                "Button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editWindow = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }